import React from 'react';
import createTaxonomyLink from '../utils/createTaxonomyLink';
import {connectToStore} from './Provider';
import {Link} from 'gatsby';

const CtaCallout = ({
	title,
	subtitle,
	cta,
	openVideoModal,
}) => {
	let ctaButton;
	let ctaMobile;

	if (cta._type === 'link') {
		if (cta.url[0] === '/') {
			ctaButton = (
				<Link
					className="button--primary-black min-width show--md"
					title={cta.title}
					to={cta.url}>
					{cta.title}
				</Link>
			);
			ctaMobile = (
				<Link
					className="button--primary-black full-width hide--md"
					title={cta.title}
					to={cta.url}>
					{cta.title}
				</Link>
			);
		} else {
			ctaButton = (
				<a
					className="button--primary-black min-width show--md"
					title={cta.title}
					href={cta.url}>
					{cta.title}
				</a>
			);
			ctaMobile = (
				<a
					className="button--primary-black full-width hide--md"
					title={cta.title}
					href={cta.url}>
					{cta.title}
				</a>
			);
		}
	} else if (cta._type === 'videoModalLink') {
		ctaButton = (
			<button
				titlke={cta.title}
				className="button--primary-black min-width show--md"
				onClick={() => openVideoModal(cta.videoId)}
				name="video">
				{cta.title}
			</button>
		);
		ctaMobile = (
			<button
				title={cta.title}
				className="button--primary-black full-width hide--md"
				onClick={() => openVideoModal(cta.videoId)}
				name="video">
				{cta.title}
			</button>
		);
	} else if (cta._type === 'taxonomyLink') {
		ctaButton = (
			<Link
				className="button--primary-black min-width show--md"
				title={cta.title}
				to={createTaxonomyLink(cta.taxonomies)}>
				{cta.title}
			</Link>
		);
		ctaMobile = (
			<Link
				className="button--primary-black full-width hide--md"
				title={cta.title}
				to={createTaxonomyLink(cta.taxonomies)}>
				{cta.title}
			</Link>
		);
	}

	return (
		<div className="mt10 mb10 mb12--md grid-container contained">
			<div className="row align--center">
				<div className="col c10--md">
					<h3 className="tc fw--600 uppercase mb2 mb4--md">
						{subtitle}
					</h3>
					<h2 className="tc domaine--large mb4 m--auto callout__title">
						{title}
					</h2>
					<div className="tc">
						{ctaButton}
						{ctaMobile}
					</div>
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = () => ({});

const mapStoreToProps = ({
	openVideoModal,
}) => ({
	openVideoModal,
});

export default connectToStore(mapStateToProps, mapStoreToProps)(CtaCallout);